<div id="desktop-not-found">
    <span class="big">404 - Not Found</span>
    <span class="small">Sad lyfe :&#40;</span>
    <hr>
    <a href="/">Back to start page</a>
</div>